import { lazy } from 'react';
import { Permission } from '@condo/domain';
import type { RamRouteObject } from '@/shared/lib/permissions';

const InvoicesListPage = lazy(() => import('@/pages/invoices/InvoicesListPage'));
const InvoiceDetailPage = lazy(() => import('@/pages/invoices/InvoiceDetailPage'));

export const invoiceRoutes: RamRouteObject[] = [
    {
        path: 'invoices',
        element: <InvoicesListPage />,
        permissions: [Permission.FinanceInvoiceList],
        name: 'invoices.list',
    },
    {
        path: 'invoices/:invoiceId',
        element: <InvoiceDetailPage />,
        permissions: [Permission.FinanceInvoiceList],
        name: 'invoices.detail',
    },
];
